







































































































































import Vue from "vue";
import { Component } from "vue-property-decorator";
import CbxIncomeType from "@/views/lookups/CbxIncomeType.vue";
import CbxYesNoDefault from "@/views/lookups/CbxYesNoDefault.vue";
import CbxTaxTreatment from "@/views/lookups/CbxTaxTreatment.vue";
import CbxIncomeCategory from "@/views/lookups/CbxIncomeCategory.vue";
import {
  FactFindIncomeDto,
  CreateIncomeCommand,
  YesNoDefaultDto,
  OwnerDto,
  IncomeTypeDto,
  IncomeCategoryDto,
  TaxTreatmentDto,
  FactFindAssetDto,
  UpdateIncomeCommand,
  ClientSelector
} from "@/api/ClientPortalApiClient";
import ApiFactory from "../../api/ApiFactory";
import CbxOwner from "@/views/lookups/CbxOwner.vue";
import AlertService from "@/services/alert.service";
import { LoadingSpinnerService } from "@/store";
import { FormatDate } from "../../filters/FormatDate";

@Component({
  components: {
    CbxOwner,
    CbxIncomeType,
    CbxYesNoDefault,
    CbxTaxTreatment,
    CbxIncomeCategory
  }
})
export default class FactFindIncomes extends Vue {
  private alertService = new AlertService();
  private contactId: number = 0;
  private incomes: FactFindIncomeDto[] = [];
  private emptyIncome = new FactFindIncomeDto();
  private displayModel = new FactFindIncomeDto();
  private selectIncome = new FactFindIncomeDto();
  private formEnabled: boolean = false;
  private mode: string = "default";
  private clientNames: OwnerDto[] = [];
  private modelSig = "";

  async created() {
    this.contactId = parseInt(this.$route.params.contactId);
    await this.getIncomes(true);
    await this.getClientSelectorNames();
  }

  $refs!: {
    owner: CbxOwner;
    incomeType: CbxIncomeType;
    mainForm: HTMLFormElement;
  };

  private saveIncome(e: Event) {
    e.preventDefault();
    if (this.mode === "update") {
      this.update();
    } else if (this.mode === "create") {
      this.createNew();
    }
  }

  private async getClientSelectorNames() {
    const api = ApiFactory.CreateDataClient();
    const data = await api.owner_Index(this.contactId);
    this.clientNames = data || [];
  }

  private async createNew(): Promise<boolean> {
    LoadingSpinnerService.Show("Saving new Income...");
    const api = ApiFactory.CreateDataClient();
    let cmd = new CreateIncomeCommand();

    cmd.contactId = this.contactId;
    cmd.incomeOwner = this.displayModel.incomeOwner;
    cmd.companySource = this.displayModel.companySource;
    cmd.incomeTypeOthers = this.displayModel.incomeTypeOthers;
    cmd.amountPerYear = this.displayModel.amountPerYear;
    cmd.dateEnded = FormatDate.forApi(this.displayModel.dateEnded);
    cmd.dateStarted = FormatDate.forApi(this.displayModel.dateStarted);

    if (this.displayModel.incomeType) {
      cmd.incomeTypeId = this.displayModel.incomeType.id;
    }

    try {
      const result = await api.factFindIncome_IndexPOST(cmd);
      if (result) {
        await this.getIncomes();
        this.displayModel =
          this.incomes.find(x => x.id === result) || this.displayModel;
        this.mode = "update";
        this.modelSig = this.displayModel.toJSON();
        LoadingSpinnerService.Success("Income saved successfully");
        return true;
      } else {
        LoadingSpinnerService.Failure(
          "Could not save Income. Please try again."
        );
      }
    } catch (e) {
      LoadingSpinnerService.Failure("Could not save Income. Please try again.");
    }

    return false;
  }

  private async update(): Promise<boolean> {
    LoadingSpinnerService.Show("Updating Income...");
    const api = ApiFactory.CreateDataClient();
    let cmd = new UpdateIncomeCommand();

    cmd.contactId = this.contactId;
    cmd.id = this.displayModel.id;
    cmd.incomeOwner = this.displayModel.incomeOwner;
    cmd.companySource = this.displayModel.companySource;
    cmd.incomeTypeOthers = this.displayModel.incomeTypeOthers;
    cmd.amountPerYear = this.displayModel.amountPerYear;
    cmd.dateEnded = FormatDate.forApi(this.displayModel.dateEnded);
    cmd.dateStarted = FormatDate.forApi(this.displayModel.dateStarted);

    if (this.displayModel.incomeType) {
      cmd.incomeTypeId = this.displayModel.incomeType.id;
    }

    try {
      var result = await api.factFindIncome_IndexPUT(cmd);
      if (result) {
        this.modelSig = JSON.stringify(this.displayModel.toJSON()).toString();
        LoadingSpinnerService.Success("Income updated successfully");

        return true;
      } else {
        LoadingSpinnerService.Failure(
          "Could not save Income. Please try again."
        );
      }
    } catch (e) {
      LoadingSpinnerService.Failure("Could not save Income. Please try again.");
    }

    return false;
  }

  private async getIncomes(showLoader: boolean | undefined = undefined) {
    if (showLoader) LoadingSpinnerService.Show("Loading Incomes...");
    const api = ApiFactory.CreateDataClient();
    try {
      const result = await api.factFindIncome_IndexAll(this.contactId);
      this.incomes = result || [];
      if (showLoader) LoadingSpinnerService.Hide();
    } catch (e) {
      this.incomes = [];
      LoadingSpinnerService.Failure(
        "Could not load Incomes. Please try again."
      );
    }
  }

  private async rowSelected(item: FactFindIncomeDto) {
    if (!(await this.checkForChanges())) {
      return;
    }

    this.formEnabled = true;
    this.mode = "update";
    this.displayModel = item;
    this.displayModel.dateStarted = FormatDate.forInput(item.dateStarted);
    this.displayModel.dateEnded = FormatDate.forInput(item.dateEnded);

    this.modelSig = JSON.stringify(this.displayModel.toJSON()).toString();
    if (this.displayModel.incomeOwner) {
      this.$refs.owner.setSelected(this.displayModel.incomeOwner);
    } else {
      this.$refs.owner.setSelected(ClientSelector.Main);
    }

    this.$refs.incomeType.setSelected(this.displayModel.incomeType);
  }

  private createClicked() {
    this.clearData();
    this.mode = "create";
    this.formEnabled = true;
  }

  private updateClicked() {
    this.mode = "update";
    this.formEnabled = true;
  }

  private clearData() {
    this.displayModel = this.emptyIncome;
    this.displayModel.incomeOwner = ClientSelector.Main;
    this.$refs.owner.setSelected(ClientSelector.Main);
    this.$refs.incomeType.setSelected(new IncomeTypeDto());
  }

  public async checkForChanges(): Promise<boolean> {
    if (this.isDisplayModelEmpty() == false) {
      if (this.hasChanges() == true) {
        if (confirm("Would you like to save your changes?")) {
          return await this.saveChanges();
        }
      }
    }

    return true;
  }

  public async saveChanges(): Promise<boolean> {
    if (this.$refs.mainForm.checkValidity()) {
      if (this.mode === "update") {
        return await this.update();
      } else if (this.mode === "create") {
        return await this.createNew();
      }

      return true;
    }

    this.alertService.error(
      "Form Validation Failed",
      "Please complete all required fields"
    );

    return false;
  }

  private isDisplayModelEmpty(): boolean {
    return (
      this.mode !== "create" &&
      JSON.stringify(this.displayModel.toJSON()) ===
        JSON.stringify(this.emptyIncome.toJSON())
    );
  }

  private hasChanges(): boolean {
    const s1 = JSON.stringify(this.displayModel.toJSON()).toString();
    if (s1 !== this.modelSig) {
      return true;
    } else {
      return false;
    }
  }

  private ownerSelected(owner: ClientSelector) {
    this.displayModel.incomeOwner = owner;
  }
  private yesNoSelected(domesticIncome: YesNoDefaultDto) {
    this.displayModel.isDomesticIncome = domesticIncome;
  }
  private incomeTypeSelected(incomeType: IncomeTypeDto) {
    this.displayModel.incomeType = incomeType;
  }

  private incomeDisplayName(income: FactFindIncomeDto): string {
    const owner = this.clientNames.find(x => x.id === income.incomeOwner);
    return (
      (owner ? owner.name : "") +
      " - " +
      (income.incomeType ? income.incomeType.name : "")
    );
  }
}
